
const ValidationSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center space-y-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            The Intersection of <span className="text-teal-600">Expertise</span>
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-scales-3-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">25+ Years</h3>
              <p className="text-gray-700 text-lg">
                <strong>Litigation Experience</strong><br/>
                Courtroom-tested liability analysis, regulatory defense strategies, and strategic risk assessment honed over two decades in high-stakes litigation environments
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-graduation-cap-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">PhD</h3>
              <p className="text-gray-700 text-lg">
                <strong>Ethics, Law, and Policy</strong><br/>
                Advanced scholarship in nonhuman ethics and legal personhood, informing a deeply nuanced approach and essential policy foresight to address high-stakes AI governance now and tomorrow
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">AIGP</h3>
              <p className="text-gray-700 text-lg">
                <strong>Certified (Pending)</strong><br/>
                Latest global AI governance standards, best practices certification, and required conformance frameworks for emerging mandates like the EU AI Act
              </p>
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white p-12 rounded-lg">
            <blockquote className="text-2xl lg:text-3xl font-light leading-relaxed text-center">
              "My counsel integrates courtroom-tested liability analysis, policy-to-governance interpretation, and practical ethics to deliver robust, auditable corporate frameworks."
            </blockquote>
            <div className="mt-8 text-center">
              <p className="text-xl text-gray-300">
                <strong>AI Governance Counsel</strong>
              </p>
              <p className="text-lg text-gray-400 mt-2">
                Strategic Legal & Policy Consultant
              </p>
            </div>
          </div>
          
          <div className="bg-teal-50 border border-teal-200 p-8 rounded-lg">
            <div className="flex items-center justify-center mb-4">
              <i className="ri-star-line text-teal-600 text-2xl mr-3"></i>
              <h3 className="text-2xl font-bold text-teal-800">Client Validation</h3>
            </div>
            <p className="text-xl text-teal-700 font-medium">
              References and detailed testimonials available upon request
            </p>
            <p className="text-lg text-teal-600 mt-2">
              Confidential case studies demonstrating successful regulatory compliance 
              and litigation prevention outcomes
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValidationSection;
